<button mat-raised-button (click)="openDialogNuevoPropietario()" *appRole="['Propietarios.Crear']">
  <mat-icon>add</mat-icon>
  Nuevo  propietario
</button>
